var _rect, _path, _rect2, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipationAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9C1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 12.9971H13.9979C12.8929 12.9971 11.9971 13.8929 11.9971 14.9979V27.0029C11.9971 28.1079 12.8929 29.0038 13.9979 29.0038H16.9992",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.998,
    y: 10.9963,
    width: 8.00333,
    height: 4.00167,
    rx: 1,
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.002 12.9971H26.0028C27.1078 12.9971 28.0036 13.8929 28.0036 14.9979V20",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0013 29.0038C21.3441 29.0027 20.001 27.6596 20 26.0025V26.0025C20.001 24.3454 21.3441 23.0023 23.0013 23.0013",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0029 23.0013C27.6601 23.0023 29.0032 24.3454 29.0042 26.0025V26.0025C29.0032 27.6596 27.6601 29.0027 26.0029 29.0038",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.001 26.0025H26.0022",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipationAgreement);
export default __webpack_public_path__ + "static/media/ParticipationAgreement.a0431fc65f88f24de5dcb1aa41441d4b.svg";
export { ForwardRef as ReactComponent };